/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./FactoryStatus.vue?vue&type=template&id=aaf0f40e&scoped=true&"
import script from "./FactoryStatus.vue?vue&type=script&lang=js&"
export * from "./FactoryStatus.vue?vue&type=script&lang=js&"
import style0 from "./FactoryStatus.vue?vue&type=style&index=0&id=aaf0f40e&prod&lang=scss&scoped=true&"
import style1 from "./FactoryStatus.vue?vue&type=style&index=1&id=aaf0f40e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf0f40e",
  null
  
)

export default component.exports